import { injectScript } from '../utils/script';
import { getBrand } from '../../../core/components/OpenGraph/OpenGraphProductData';
const gtag = () => window.gtag;
function productToItem(product, selectedVariation, useArticleNumberAsId = false, brandCustomField, category) {
    var _a, _b, _c, _d;
    return {
        item_name: product === null || product === void 0 ? void 0 : product.name,
        item_id: useArticleNumberAsId
            ? product === null || product === void 0 ? void 0 : product.articleNumber
            : (_a = product === null || product === void 0 ? void 0 : product.id) === null || _a === void 0 ? void 0 : _a.toString(),
        price: ((_b = selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.price) === null || _b === void 0 ? void 0 : _b.incVat) || ((_c = product === null || product === void 0 ? void 0 : product.price) === null || _c === void 0 ? void 0 : _c.incVat),
        item_category: category,
        item_variant: (_d = selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.values) === null || _d === void 0 ? void 0 : _d.join('_'),
        item_brand: getBrand(product, brandCustomField)
    };
}
export function ga4Tracker({ trackingId, additionalGtagTrackingIds = [], currency, brandCustomField, useArticleNumberAsId = false }) {
    return {
        name: 'ga4',
        initBrowser() {
            const script = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
            const w = window;
            w.dataLayer = w.dataLayer || [];
            w.dataLayer.push({
                'gtm.start': new Date().getTime(),
                event: 'gtm.js',
                originalLocation: document.location.protocol +
                    '//' +
                    document.location.hostname +
                    document.location.pathname +
                    document.location.search
            });
            w.gtag = function gtag() {
                w.dataLayer.push(arguments);
            };
            w.gtag('js', new Date());
            if (process.env.REACT_APP_DEBUG_MODE === 'true') {
                gtag()('config', trackingId, {
                    debug_mode: true
                });
            }
            else {
                gtag()('config', trackingId);
            }
            additionalGtagTrackingIds.forEach((id) => {
                gtag()('config', id);
            });
            injectScript({ src: script });
            gtag();
        },
        trackProduct({ quantity, action, product, selectedVariation, list, listName, index, category }, context) {
            const productItem = Object.assign(Object.assign({}, productToItem(product, selectedVariation, useArticleNumberAsId, brandCustomField, category)), { quantity, item_list_name: list || listName || context.list, index: index });
            switch (action) {
                case 'click':
                    gtag()('event', 'select_item', {
                        content_type: 'product',
                        currency,
                        value: product.price.incVat,
                        items: [productItem]
                    });
                    break;
                case 'view':
                    gtag()('event', 'view_item', {
                        currency,
                        value: product.price.incVat,
                        items: [productItem]
                    });
                    break;
                case 'add':
                    gtag()('event', 'add_to_cart', {
                        currency,
                        value: product.price.incVat,
                        items: [productItem]
                    });
                    break;
                case 'remove':
                    gtag()('event', 'remove_from_cart', {
                        currency,
                        value: product.price.incVat,
                        items: [productItem]
                    });
                    break;
                default:
                    console.log('Error: Gtag can not track action ' + action);
                    break;
            }
        },
        // This event is disabled in GA4 so that the event fires on the Checkout Page instead using tag manager
        // trackCartCheckout({ cart }, _context) {
        //   const items: GA4Item[] = cart.items.map((item) => ({
        //     ...productToItem(
        //       item.product as Product,
        //       item.variant,
        //       useArticleNumberAsId,
        //       brandCustomField
        //     ),
        //     quantity: item.quantity
        //   }));
        //   gtag()('event', 'begin_checkout', {
        //     currency: currency,
        //     value: cart.productTotal.incVat,
        //     items
        //   });
        // },
        trackPageView({ pathname, title }, _context) {
            gtag()('event', 'page_view', {
                currency,
                page_path: pathname,
                page_title: title
            });
        },
        trackList({ listName, products, category }, _context) {
            const items = products.map((product, i) => {
                var _a;
                return (Object.assign(Object.assign({}, productToItem(product, null, useArticleNumberAsId, brandCustomField)), { price: (_a = product.price) === null || _a === void 0 ? void 0 : _a.incVat, item_list_name: listName, index: i }));
            });
            gtag()('event', 'view_item_list', {
                item_list_id: category,
                item_list_name: listName,
                items
            });
        },
        trackExperiment({ id, variant }, _context) {
            gtag()('config', trackingId, {
                experiments: [{ id, variant }]
            });
        },
        trackUser({ userId }, _context) {
            gtag()('event', 'authentication', { user_id: userId });
        },
        trackLogin(_props, _context) {
            gtag()('event', 'login', { trackingId });
        },
        trackRegister(_props, _context) {
            gtag()('event', 'sign_up', { trackingId });
        },
        trackAddToWishList({ articleNumber, productName }, _context) {
            gtag()('event', 'add_to_wishlist', {
                articleNumber,
                productName
            });
        }
    };
}
//# sourceMappingURL=ga4.js.map